import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";

const GantiPass = () => {
  const [input, setInput] = useState({
    current_password: "",
    new_password: "",
    new_confirm_password: "",
  });

  const handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    setInput({
      ...input,
      [name]: value,
    });
  };

  const handleChangePass = (event) => {
    event.preventDefault();

    let { current_password, new_password, new_confirm_password } = input;

    if (
      current_password.length >= 8 &&
      new_password.length >= 8 &&
      new_confirm_password.length >= 8 &&
      current_password !== new_password
    ) {
      axios
        .post(
          `https://dev-example.sanbercloud.com/api/change-password`,
          {
            current_password,
            new_password,
            new_confirm_password,
          },
          {
            headers: { Authorization: "Bearer " + Cookies.get("token") },
          }
        )
        .then((res) => {
          console.log(res);
          alert("ganti password berhasil");
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    } else {
      return alert(
        "Password minimal 8 karakter dan tidak boleh sama dengan password lama"
      );
    }

    setInput({
      current_password: "",
      new_password: "",
      new_confirm_password: "",
    });
  };

  console.log(input);
  return (
    <React.Fragment>
      <div className="h-screen">
        <div className="w-full  bg-white rounded-lg shadow dark:border md:mt-0  xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Ganti Password
            </h1>
            <form
              onSubmit={handleChangePass}
              className="space-y-4 md:space-y-6"
            >
              <div>
                <label
                  htmlFor="current_password"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Password Lama
                </label>
                <input
                  value={input.current_password}
                  onChange={handleChange}
                  type="password"
                  name="current_password"
                  id="current_password"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="new_password"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Password Baru
                </label>
                <input
                  onChange={handleChange}
                  value={input.new_password}
                  type="password"
                  name="new_password"
                  id="new_password"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="new_confirm_password"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Masukkan kembali Password Baru
                </label>
                <input
                  onChange={handleChange}
                  value={input.new_confirm_password}
                  type="password"
                  name="new_confirm_password"
                  id="new_confirm_password"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full text-white bg-cyan-500 hover:bg-cyan-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
              >
                Ganti Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GantiPass;
